import { Component, EventEmitter, Input, OnInit, Output ,OnDestroy} from "@angular/core";
import { BaseComponent } from "../../shared/base/base-component";
import { AlertService } from "../../alert-panel/alert.service";
import { LoggingPanelModel } from "../../_models/common/LoggingPanelModel";
import { ApiRequest, IApiresponse, LogObjectActionTemplateEnum } from "../../_models";
import { LoggingPanelService } from "../../_services/logging-panel/logging-panel.service";
import { ClaimsService } from "../../_services/common/claims.service";
import { Claims } from "../../_models/common/claims";
import { TranslateService } from "@ngx-translate/core";
import { StateService } from "../../_services";
import { TaxRateService } from "../../_services/tax-rate/tax-rate.service";
import { TaxSetupRequest, TaxSetupRequestInfo } from "../../_models/tax-rate/tax-setup-request";
import { ToastrService } from "ngx-toastr";
import { InformationAlertPanelModel } from "../../_models/common/informationAlertPanelModel";
import { HowDoIVideoLinks }  from "src/app/common/commonvariables";
import { Subscription } from "rxjs";
import { UkMileageRateSettingService } from "src/app/_services/advance-mileage/uk-mileage-rate-setting.service";
import { ITwoStepApprovalSaveRequest, TwoStepApprovalSaveRequest } from "src/app/_models/twostepapproval/twostepapproval";
import { TwostepapprovalService } from "src/app/_services/twostepapproval/twostepapproval.service";
import { environment } from "src/environments/environment";
import { TourService } from '../../_tour/tour.service';
import { ActivatedRoute, Router } from "@angular/router";
@Component({
    selector: 'app-tax-setup-step0',
    templateUrl: './tax-setup-step0.component.html',
    standalone: false
})

export class TaxSetupStep0Component extends BaseComponent implements OnInit,OnDestroy {
  @Input() fmSpecialObject: any;
    @Input() panelHeader: string;
    @Input() closeBtnText: string;
    @Output() closePanelEvent = new EventEmitter<boolean>();
    hasFormChanges:boolean;
    claims: Claims;
    IsINRCurrency: boolean;
    taxNamePlaceHolder: string;
    RateCode: string;
    param: string;
    taxSetupRequest: TaxSetupRequest;
    taxSetupRequestInfo: TaxSetupRequestInfo;
    TaxSetupId: number = 0;
    CanChangeTaxType: boolean;
    IsChangeInTaxType: boolean;
    videoLink = HowDoIVideoLinks.TaxSetupStep1;
    showTaxChangeAlert: boolean;
    alertSubscription: Subscription;
    IsTaxRateOn:boolean;
    setNoVAT:boolean;
    showTurnOffConfirmation: boolean = false;
    originalTaxRateState: boolean;
    constructor(
        private alertService : AlertService,
        private loggingPanelService: LoggingPanelService,
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private ukMileageRateSettingService: UkMileageRateSettingService,
        private taxRateService: TaxRateService,
        private toastr: ToastrService,
        private twoStepApprovalService: TwostepapprovalService,
        private tourService: TourService,
        private route: ActivatedRoute,
    ){
     super();
     this.claimsService.currentClaims.subscribe((claims) => {
        this.claims = claims;
        this.IsINRCurrency =
          this.claims.CurrentOrganisationCurrency.includes("INR");
      });
      this.alertSubscription = this.alertService
      .getUserActionEvent()
      .subscribe((action) => {
        if (action) {
          this.hasFormChanges = false;
          this.closePanelEvent.emit(true);
        }
      });
    }

    ngOnInit(): void {
        this.showTaxChangeAlert=false;
        this.hasFormChanges=false;
        this.RateCode = '';
        this.TaxSetupId=0;
        this.setNoVAT = false;
        this.taxNamePlaceHolder = this.translate.instant("tax_name_placeholder");
        this.GetOrganisationDetail();
        this.BindTaxSetup();
        if(!this.closeBtnText)
        {
          this.closeBtnText = this.translate.instant("back_to_wizard");
        }

        this.fnStartToggleTour();
    }

    ngOnDestroy() {
      this.tourService.destroyParallelPopups();
    }


    fnBacktoWizard()
    {
        if (this.canDeactivate()) {
          if(this.fmSpecialObject) {
            this.closePanelEvent.emit(this.fmSpecialObject); 
          }
          else
          {
            this.closePanelEvent.emit(true); 
          }
        }
        else {
            this.alertService.onFormClosed();
        }     
    }

    canDeactivate(): boolean {
        return !this.hasFormChanges;
    }

    fnShowConfigureshowLoggingAlertPanel() {
        const model = new LoggingPanelModel(
          this.claims.OrgId.toString(),
          LogObjectActionTemplateEnum.TaxSetupOnOff.toString(),
          "0"
        );
        this.loggingPanelService.onShowLogPanel(model);
    }

    onTaxNameChange() {
      this.hasFormChanges = true;
    }

    fnSetVATtype(setNoVAT:boolean,IsChanged:boolean)
    {
      this.hasFormChanges=IsChanged;  
      this.setNoVAT = setNoVAT;
      
      if(IsChanged){
         this.fnStartSaveButtonTour();
      }
              
    }
    GetOrganisationDetail() {
      this.ukMileageRateSettingService
        .SoloGetOrganisationDetail()
        .subscribe((res: IApiresponse<any>) => {
          if (res.responseInfo != null && res.responseInfo.length > 0) {
            this.IsTaxRateOn = res.responseInfo[0].isTaxRateOn; 
            this.setNoVAT = res.responseInfo[0].isTaxRateOn;  
            // Store original state to check for changes
            this.originalTaxRateState = res.responseInfo[0].isTaxRateOn;
            if(this.IsTaxRateOn)
              {
                this.fnSetVATtype(this.IsTaxRateOn,false);
              }
          }
        });
    }
    BindTaxSetup() {
      var request = new TaxSetupRequest();
      request.requestId = "1";
      request.webApiName = "getTaxRateMasterByOrg";
      request.webApiVersion = 1;
      request.requestInfo = new TaxSetupRequestInfo();
      request.requestInfo.organisationId = this.claims.OrgId;
  
      this.taxRateService
        .getTaxSetuByOrg(request, "")
        .pipe()
        .subscribe((data) => {
          if (data.statusCode == 0) {
            this.taxSetupRequestInfo = data.responseInfo;
            if (this.taxSetupRequestInfo) {
              this.TaxSetupId = this.taxSetupRequestInfo.taxSetupId;              
              this.RateCode = this.taxSetupRequestInfo.rateCode;
              this.TaxSetupId = this.taxSetupRequestInfo.taxSetupId;
            }
          }
        });
    }

    showTurnOffAlert() {
      this.showTurnOffConfirmation = true;
    }

    alertPanelReceiver(action: boolean) {
      if (action && this.showTurnOffConfirmation) {
        // User confirmed to turn off Tax Rate
        this.performTaxRateSave();
      }
      
      // Reset alert panel
      this.showTurnOffConfirmation = false;
    }

    

    Save() {
      // Check if we're turning off tax rate and show confirmation
      const turningOffTaxRate = this.originalTaxRateState === true && this.setNoVAT === false;
      
      if (turningOffTaxRate) {
        this.showTurnOffAlert();
        return;
      }
      
      // Proceed with save if no confirmation needed
      this.performTaxRateSave();
    }

    performTaxRateSave() {
      
      this.taxSetupRequest = new TaxSetupRequest();
      this.taxSetupRequest.requestId = "1";
      this.taxSetupRequest.webApiName = "SaveTaxSetup";
      this.taxSetupRequest.webApiVersion = 1;
      this.taxSetupRequest.requestInfo = new TaxSetupRequestInfo();
      this.taxSetupRequest.requestInfo.taxSetupId = this.TaxSetupId;
      this.taxSetupRequest.requestInfo.rateCode = this.RateCode;
      this.taxSetupRequest.requestInfo.organisationId = this.claims.OrgId;
      this.taxSetupRequest.requestInfo.isTaxRateOn = this.setNoVAT ? true : false;
      this.taxSetupRequest.requestInfo.createdBy = this.claims.UserId;
      this.taxSetupRequest.requestInfo.updatedBy = this.claims.UserId;
      this.taxSetupRequest.requestInfo.createdOn = null;
      this.taxSetupRequest.requestInfo.updatedOn = null;
      this.taxSetupRequest.requestInfo.wizardStep = 1;
      this.taxRateService
        .saveTaxSetup(this.taxSetupRequest, "")
        .pipe()
        .subscribe((data) => {
          if (data.statusCode == 0) {
            // this.TaxSetupId = data.responseInfo.taxSetupId;              
            // this.RateCode = data.responseInfo.rateCode;             
            this.toastr.success(this.translate.instant("success"));
            this.hasFormChanges = false;
            
            // Update claims with the new tax rate setting
            this.originalTaxRateState = this.setNoVAT ? true : false;
            this.claims.isTaxRateOn = this.setNoVAT ? true : false;
            this.claims.isManualVatOn = this.setNoVAT ? this.claims.isManualVatOn : false;
            this.claimsService.updateClaims(this.claims);
            
            // If turning off tax rate, also turn off manual VAT
            if (!this.setNoVAT) {
              this.performSave();
            }
            
            if(this.fmSpecialObject)
            {
              this.fmSpecialObject.nextPanel = true;
            }
          }
        });
    }

    performSave() {
    let request = new ApiRequest<ITwoStepApprovalSaveRequest>("UpdateManualVatOnOffForOrganisation", environment.applicationVersion, environment.requestId);
    let requestInfo = new TwoStepApprovalSaveRequest();
    requestInfo.OrgId = this.claims.OrgId;
    requestInfo.isManualVatOn = false;
    request.requestInfo = requestInfo;
    
    this.twoStepApprovalService.UpdateManualVatOnOffForOrganisation(request).subscribe((response) => {
      this.hasFormChanges = false;
      if (response.statusCode == 0) {
        // Update claims with the new manual VAT setting
        this.claims.isManualVatOn = false;
        this.claimsService.updateClaims(this.claims);
      }
    });
  }

  fnStartToggleTour(){
    const showTour = Boolean(this.route.snapshot.queryParams?.showTour);
    if (!showTour) return;

    this.tourService.showParallelFromRegistry('setup-tax-panel-toggle-tour');
  }

  fnStartSaveButtonTour(){
   const showTour = Boolean(this.route.snapshot.queryParams?.showTour);
   if (!showTour) return;
   
   this.tourService.showParallelFromRegistry('setup-tax-panel-save-tour');
  }

}